import { render, staticRenderFns } from "./ConnectDatabase.vue?vue&type=template&id=883a0566&scoped=true&lang=pug&"
import script from "./ConnectDatabase.vue?vue&type=script&lang=ts&"
export * from "./ConnectDatabase.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectDatabase.vue?vue&type=style&index=0&id=883a0566&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883a0566",
  null
  
)

export default component.exports